/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICRTouchScheduleSales } from './ICRTouchScheduleSales';
import {
    ICRTouchScheduleSalesFromJSON,
    ICRTouchScheduleSalesFromJSONTyped,
    ICRTouchScheduleSalesToJSON,
    ICRTouchScheduleSalesToJSONTyped,
} from './ICRTouchScheduleSales';
import type { CacheMeta } from './CacheMeta';
import {
    CacheMetaFromJSON,
    CacheMetaFromJSONTyped,
    CacheMetaToJSON,
    CacheMetaToJSONTyped,
} from './CacheMeta';

/**
 * 
 * @export
 * @interface ListIcrTouchConnectionScheduleSalesResponse
 */
export interface ListIcrTouchConnectionScheduleSalesResponse {
    /**
     * 
     * @type {CacheMeta}
     * @memberof ListIcrTouchConnectionScheduleSalesResponse
     */
    cache: CacheMeta;
    /**
     * 
     * @type {ICRTouchScheduleSales}
     * @memberof ListIcrTouchConnectionScheduleSalesResponse
     */
    data: ICRTouchScheduleSales;
}

/**
 * Check if a given object implements the ListIcrTouchConnectionScheduleSalesResponse interface.
 */
export function instanceOfListIcrTouchConnectionScheduleSalesResponse(value: object): value is ListIcrTouchConnectionScheduleSalesResponse {
    if (!('cache' in value) || value['cache'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListIcrTouchConnectionScheduleSalesResponseFromJSON(json: any): ListIcrTouchConnectionScheduleSalesResponse {
    return ListIcrTouchConnectionScheduleSalesResponseFromJSONTyped(json, false);
}

export function ListIcrTouchConnectionScheduleSalesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListIcrTouchConnectionScheduleSalesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'cache': CacheMetaFromJSON(json['cache']),
        'data': ICRTouchScheduleSalesFromJSON(json['data']),
    };
}

  export function ListIcrTouchConnectionScheduleSalesResponseToJSON(json: any): ListIcrTouchConnectionScheduleSalesResponse {
      return ListIcrTouchConnectionScheduleSalesResponseToJSONTyped(json, false);
  }

  export function ListIcrTouchConnectionScheduleSalesResponseToJSONTyped(value?: ListIcrTouchConnectionScheduleSalesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cache': CacheMetaToJSON(value['cache']),
        'data': ICRTouchScheduleSalesToJSON(value['data']),
    };
}

